import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=35bce142&scoped=true"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"
import style0 from "./Rules.vue?vue&type=style&index=0&id=35bce142&prod&lang=css"
import style1 from "./Rules.vue?vue&type=style&index=1&id=35bce142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bce142",
  null
  
)

export default component.exports